import {
  Box,
  FormHelperText,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import { Controller } from "react-hook-form";

export const TextWithCount = ({
  control,
  name,
  label,
  maxLength,
  ...props
}) => {
  return (
    <Box sx={{ mb: 1 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <InputLabel
          as="div"
          sx={{
            color: "rgba(93, 88, 108, 1)",
            fontSize: "14px",
            fontWeight: 500,
          }}
          htmlFor={`field-${name}`}
        >
          {label}
        </InputLabel>

        <Typography
          as="label"
          sx={{
            color: "rgba(93, 88, 108, 1)",
            fontSize: "12px",
            fontWeight: 500,
          }}
        >
          Máx {maxLength} caracteres
        </Typography>
      </Box>
      <Controller
        name={name}
        control={control}
        rules={{
          required: {
            value: true,
            message: "Campo obrigatório",
          },
          minLength: {
            value: 3,
            message: "Campo obrigatório, mínimo de 3 caracteres",
          },
          maxLength: {
            value: maxLength,
            message: `Máximo de ${maxLength} caracteres`,
          },
        }}
        render={({ field, fieldState: { error, isTouched } }) => (
          <Box sx={{ position: "relative" }}>
            <TextField
              {...field}
              id={`field-${name}`}
              inputProps={{
                maxlength: maxLength,
              }}
              error={isTouched && !!error}
              helperText={isTouched && error ? error.message : " "}
              fullWidth
              variant="standard"
              {...props}
            />
            <FormHelperText
              error={isTouched && !!error}
              sx={{
                position: "absolute",
                right: 0,
                bottom: 0,
              }}
            >
              {field?.value?.length || 0}/{maxLength}
            </FormHelperText>
          </Box>
        )}
      />
    </Box>
  );
};
